import '@operato/dataset/ox-data-entry-form.js'
import '@operato/dataset/ox-checklist-entry-form.js'

import gql from 'graphql-tag'
import { css, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { ScrollbarStyles } from '@operato/styles'
import { OxDataEntryForm } from '@operato/dataset/ox-data-entry-form.js'
import { OxChecklistEntryForm } from '@operato/dataset/ox-checklist-entry-form.js'

import { DataSet } from '@operato/dataset'

@customElement('activity-data-collect-edit')
export class DataCollectActivityEdit extends localize(i18next)(LitElement) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      ox-data-entry-form,
      ox-checklist-entry-form {
        flex: 1;
        padding: 10px;
        overflow: auto;
      }
    `
  ]

  @property({ type: Object }) input?: any
  @property({ type: Object }) output?: any

  @state() dataSet?: DataSet & { id: string; entryType?: string; entryView?: string }

  @query('ox-data-entry-form') dataEntryForm?: OxDataEntryForm
  @query('ox-checklist-entry-form') checklistEntryForm?: OxChecklistEntryForm

  get entryForm() {
    const entryType = this.dataSet?.entryType
    const entryView = this.dataSet?.entryView

    switch (entryType) {
      case 'generated':
        return this.dataEntryForm
      case 'checklist':
        return this.checklistEntryForm
      case 'board':
        break
      case 'page':
        break
      default:
        return this.dataEntryForm
        break
    }
  }

  render() {
    return html` <div class="container">${this.renderEntryForm()}</div> `
  }

  private renderEntryForm() {
    const entryType = this.dataSet?.entryType
    const entryView = this.dataSet?.entryView

    switch (entryType) {
      case 'generated':
        return html`<ox-data-entry-form
          .dataSet=${this.dataSet}
          .value=${this.output}
          @change=${this._updateDataItems}
        ></ox-data-entry-form>`
      case 'checklist':
        return html`<ox-checklist-entry-form
          .dataSet=${this.dataSet}
          .value=${this.output}
          @change=${this._updateDataItems}
        ></ox-checklist-entry-form>`
      case 'board':
        break
      case 'page':
        break
      default:
        return html`<ox-data-entry-form
          .dataSet=${this.dataSet}
          .value=${this.output}
          @change=${this._updateDataItems}
        ></ox-data-entry-form>`
        break
    }
  }

  async _updateDataItems(e: CustomEvent) {
    e.stopPropagation()

    //@ts-ignore TODO replace with following line and confirm
    this.output = this.entryForm.value

    this.dispatchEvent(
      new CustomEvent('change', {
        detail: this.output
      })
    )
  }

  updated(changes) {
    if (changes.has('input')) {
      this.fetchDataSet()
    }
  }

  async fetchDataSet() {
    const id = this.input.dataSetId

    if (id) {
      const response = await client.query({
        query: gql`
          query ($id: String!) {
            dataSet(id: $id) {
              id
              name
              description
              useCase
              entryType
              entryView
              dataItems {
                name
                description
                active
                hidden
                tag
                group
                subgroup
                type
                unit
                options
                quota
                spec
                stat
              }
            }
          }
        `,
        variables: {
          id
        }
      })

      this.dataSet = response.data.dataSet
    }
  }
}
